<script>
import BotTemplateCard from '@/components/bot-template/BotTemplateCard.vue'
export default {
  props: {
    botTemplate: Object
  },
  components: {
    BotTemplateCard
  }
}
</script>

<template>
  <bot-template-card :hex-id="botTemplate.hexId"></bot-template-card>
</template>
